/*CUSTOMERS*/
const Customers = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/Customers.vue');
const Carts = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/Carts.vue');
const Orders = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/Orders.vue');
//user
const CustomersUser = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/customers/User.vue');
const CustomersUserInfo = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/customers/user/Info.vue');
const CustomersUserOrders = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/customers/user/Orders.vue');
const CustomersUserCarts = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/customers/user/Carts.vue');
const CustomersUserWallet = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/customers/user/Wallet.vue');
const CustomersUserStatistics = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/customers/user/Statistics.vue');
const CustomersUserLogins = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/customers/user/Logins.vue');
//orders
const CustomersCart = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/customers/Cart.vue');
const CustomersOrder = () => import(/* webpackChunkName: "loyaltyvenue" */ './store/customers/Order.vue');

export default [
  {
    path: 'customers',
    name: 'loyaltyvenue.store.customers',
    component: Customers,
    meta: {
      icon: 'users',
      trans: 'loyaltyvenue:general.titles.customers',
    },
  },
  {
    path: 'carts',
    name: 'loyaltyvenue.store.carts',
    component: Carts,
    meta: {
      icon: 'cart',
      trans: 'loyaltyvenue:general.titles.carts',
    },
    children: [
      {
        path: ':id',
        name: 'loyaltyvenue.store.customers.cart',
        props: true,
        component: CustomersCart,
        meta: {
          trans: 'loyaltyvenue:customers.tabs.carts',
        }
      },
    ],
  },
  {
    path: 'orders',
    name: 'loyaltyvenue.store.orders',
    component: Orders,
    meta: {
      icon: 'orderlist',
      trans: 'loyaltyvenue:general.titles.orders',
    },
  },
  {
    path: 'orders/:id',
    name: 'loyaltyvenue.store.customers.order',
    component: CustomersOrder,
    props: true,
    meta: {
      trans: 'loyaltyvenue:orders.title',
      up: 'loyaltyvenue.store.orders',
    },
  },
  {
    path: 'customers/:id',
    name: 'loyaltyvenue.store.customers.user',
    redirect: {name: 'loyaltyvenue.store.customers.user.info'},
    component: CustomersUser,
    props: true,
    meta: {
      trans: 'loyaltyvenue:customers.customer',
      up: 'loyaltyvenue.store.customers',
    },
    children: [
      {
        path: 'info',
        name: 'loyaltyvenue.store.customers.user.info',
        component: CustomersUserInfo,
      },
      {
        path: 'orders',
        name: 'loyaltyvenue.store.customers.user.orders',
        component: CustomersUserOrders,
      },
      {
        path: 'carts',
        name: 'loyaltyvenue.store.customers.user.carts',
        component: CustomersUserCarts,
      },
      {
        path: 'wallet',
        name: 'loyaltyvenue.store.customers.user.wallet',
        component: CustomersUserWallet,
      },
      {
        path: 'statistics',
        name: 'loyaltyvenue.store.customers.user.stats',
        component: CustomersUserStatistics,
      },
      {
        path: 'logins',
        name: 'loyaltyvenue.store.customers.user.logins',
        component: CustomersUserLogins,
      },
    ],
  },
];


// WEBPACK FOOTER //
// ./src/apps/loyaltyvenue/routes_customers.js